import { Routes } from "@angular/router";

export const evaluationInterestsRoutes: Routes = [
  {
    path: "",
    loadComponent: () => import("./evaluations-interests.component").then((c) => c.EvaluationsInterestsComponent),
    children: [
      {
        path: "",
        title: "FRIENDS_OF_OMAN_MUSEUM.EVALUATIONS_AND_INTERESTS",
        data: {
          tabs: [
            {
              key: "Interests",
              title: "MY_PROFILE.INTERESTS_CARD",
              routerLink: "interests",
            },
            {
              key: "EvaluationForm",
              title: "FRIENDS_OF_OMAN_MUSEUM.EVALUATION_FORM",
              routerLink: "evaluation-form",
            },
          ],
        },
        loadComponent: () =>
          import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
            (c) => c.BaseTabsManagementComponent,
          ),
        children: [
          {
            path: "",
            redirectTo: "interests",
            pathMatch: "full",
          },
          {
            path: "evaluation-form",
            loadComponent: () => import("./pages/evaluation-form/evaluation-form.component").then((c) => c.EvaluationFormComponent),
          },
          {
            path: "interests",
            loadComponent: () => import("./pages/interests/interests.component").then((c) => c.InterestsComponent),
          },
        ],
      },
    ],
  },
];
